import { cva } from 'class-variance-authority';

export const onCourseSummaryRaceRowSkeletonSurfaceVariants = cva(
  'box-border flex w-full min-w-0 max-w-full flex-col gap-6 rounded-3xl border border-border bg-muted p-4 px-6'
);
